let scrollTop = 0
let lockCount = 0
let previousBodyStyles: {
  position: string
  top: string
  left: string
  right: string
  width: string
} | null = null

export const lockBodyScroll = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return

  // 일반 BottomSheet 위에 High-Z BottomSheet가 열릴 수 있다. 이미 잠긴
  // 상태에서는 최초 스크롤 위치와 body 스타일을 덮어쓰지 않는다.
  if (lockCount > 0) {
    lockCount += 1
    return
  }

  const doc = document.documentElement
  scrollTop = window.scrollY || doc.scrollTop
  previousBodyStyles = {
    position: document.body.style.position,
    top: document.body.style.top,
    left: document.body.style.left,
    right: document.body.style.right,
    width: document.body.style.width,
  }

  document.body.style.position = "fixed"
  document.body.style.top = `-${scrollTop}px`
  document.body.style.left = "0"
  document.body.style.right = "0"
  document.body.style.width = "100%"
  lockCount = 1
}

export const unlockBodyScroll = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return
  if (lockCount === 0) return

  lockCount -= 1
  if (lockCount > 0) return

  const styles = previousBodyStyles
  const scrollTopToRestore = scrollTop

  document.body.style.position = styles?.position ?? ""
  document.body.style.top = styles?.top ?? ""
  document.body.style.left = styles?.left ?? ""
  document.body.style.right = styles?.right ?? ""
  document.body.style.width = styles?.width ?? ""

  previousBodyStyles = null
  scrollTop = 0
  window.scrollTo(0, scrollTopToRestore)
}
